import { log } from './logger'
import { writeWithFallback } from './clipboardFallback'

// The textarea goes inside the open dialog: Radix's focus trap pulls focus back
// from anything outside it, which would clear the selection before the copy.
function execCommandCopy(text: string): boolean {
  const prev = document.activeElement as HTMLElement | null
  const container = prev?.closest('[role="dialog"],[role="alertdialog"]') ?? document.body
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.readOnly = true
  textarea.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;font-size:12pt'
  try {
    container.appendChild(textarea)
    textarea.focus({ preventScroll: true })
    textarea.select()
    textarea.setSelectionRange(0, text.length)
    return document.execCommand('copy')
  } catch {
    return false
  } finally {
    textarea.remove()
    prev?.focus({ preventScroll: true })
  }
}

// Old Android WebViews (Chromium 90) reject the async Clipboard API on the
// Capacitor origin with NotAllowedError, but still honor execCommand('copy')
// inside the tap's user activation (#592, #593).
export async function writeClipboard(text: string): Promise<void> {
  const result = await writeWithFallback(text, {
    writeText: navigator.clipboard?.writeText?.bind(navigator.clipboard),
    execCopy: execCommandCopy,
  })
  if (result.path === 'execCommand') {
    log('clipboard', 'execCommand fallback used', { error: String(result.primaryErr) })
  }
}
